import {PersonnelSettingVI} from "./personnel/vi";
import {ApplicationSettingVI} from "./applicaiton/vi";
import {TimekeepingSettingVI} from "./timekepping/vi";

export const SettingVI = {
    "setting": {
        "title": "Cài đặt",
        "back" : "Quay lại",
        "system": {
            "configuration": "Phần mềm",
            "admin": "Hệ thống",
            "automatic": "Tự động",
            "email": "Email"
        },
        "workplace": {
            "work": "Công việc",
            "officialDispatch": "Văn bản",
            "calendar": "Lịch biểu"
        },
        "hrm": {
            "application": "Đơn từ",
            "asset": "Tài sản",
            "recruitment": "Tuyển dụng",
            "personnel": "Nhân sự",
            "timekeeping": "Chấm công",
        },
        "crm": {
            "customerService": "CSKH",
            "receiptPayment": "Bán hàng",
            "wareHouse": "Kho hàng",
            "purchases": "Mua hàng",
        }
    },
    ...PersonnelSettingVI,
    ...ApplicationSettingVI,
    ...TimekeepingSettingVI,
}